module.exports = __webpack_public_path__ + "static/media/createCallLinkIcon.7f492dc4.svg";